/**
 * Privacy Policy Intro paragraph
 * Exact legal text from the approved prototype.
 */

import { Link } from 'react-router-dom';

export const PrivacyPolicyIntro = () => (
  <p className="font-termina pt-16 pb-5">
    This Privacy Policy governs the collection of personal information by The
    bQuest, LLC ("bQuest," "we," "us" or "our"), through
    https://www.thebQuest.com/, including any and all subdomains or
    subdirectories thereof (the "bQUEST URL"), applications available through
    mobile, desktop, or device applications, bQuest-controlled social media
    pages (including Facebook, Instagram, Spotify, YouTube, LinkedIn, and X),
    and any and all developer accounts connected to bQuest or a bQuest URL
    accessed through the iOS App Store, the Google Play Store, or any other
    platform for the distribution of software applications (collectively, the
    "bQuest Platform"). If you do not agree to the terms and conditions of this
    Privacy Policy, including having your personal information, as defined
    below, used in any of the ways described in this Privacy Policy, you may
    not be able to use certain parts or features of our Services. bQuest may
    update this Privacy Policy from time to time in our sole discretion. It is
    your responsibility to review our Privacy Policy for any changes each time
    that you use the Services and you are bound by such changes. Your use of
    the Services following us posting a new privacy policy on the bQuest
    Platform signifies that you agree to and accept the Privacy Policy as
    modified. Capitalized terms not otherwise defined herein will have the
    meaning given to them in our{' '}
    <Link
      className="underline text-2xl"
      to="/terms-of-use"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms of Service
    </Link>
    {'.'}
  </p>
);
